import * as React from "react";
import styles from "./style.module.less";
export default class CenteredLayout extends React.Component {
    render() {
        return <div className={styles.container}>{this.props.children}</div>;
    }
    static displayName = "CenteredLayout";
}
